export const directoryBranchSectionIds = {
  act: 'act',
  cost: 'cost',
  fees: 'fees',
  market: 'market',
  service: 'service',
} as const;
